import React from 'react'
import PropTypes from 'prop-types'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './style.scss'

export const SearchRequestError = ({ retry, isValidating, t, i18n }) => {
  const thai = i18n?.language?.split('-')[0] === 'th'
  const copy = (key, en, th) => hasLocizeTranslation(t, key, thai ? th : en)

  return (
    <div className="search-request-error">
      <style jsx>{styles}</style>
      <p role="status">
        {copy(
          'SEARCH_REQUEST_FAILED',
          'We couldn’t load these results. Please try again.',
          'ไม่สามารถโหลดผลการค้นหาได้ กรุณาลองอีกครั้ง',
        )}
      </p>
      <button
        type="button"
        disabled={isValidating}
        onClick={() => retry().catch(() => undefined)}
      >
        {isValidating
          ? copy(
              'SEARCH_RECOVERY_RETRYING',
              'Trying again…',
              'กำลังลองอีกครั้ง…',
            )
          : copy('SEARCH_RECOVERY_RETRY', 'Try again', 'ลองอีกครั้ง')}
      </button>
    </div>
  )
}

SearchRequestError.propTypes = {
  retry: PropTypes.func.isRequired,
  isValidating: PropTypes.bool,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({ language: PropTypes.string }),
}

SearchRequestError.defaultProps = { isValidating: false, i18n: undefined }

export default withI18next()(SearchRequestError)
